



























import { index } from '@/api/drama_completions'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  screening: Record<string, any> = {
    status: 0
  }

  config: Record<string, any> = {
    api: index,
    include: 'brand',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'body', label: '内容' },
      { prop: 'status', label: '状态', width: 100, slot: true },
      { prop: 'created_at', label: '反馈时间', width: 150 }
    ]
  }
}
